import { createFileRoute } from "@tanstack/react-router";
import type { ErrorPageProps } from "../components/ErrorPage";
import ErrorPage from "../components/ErrorPage";

function DedicatedErrorPage({ statusCode = 200 }: ErrorPageProps) {
  return <ErrorPage statusCode={statusCode} />;
}

export const Route = createFileRoute("/error")({
  component: DedicatedErrorPage,
});
